import React from 'react'

const IconVocabulary = ({color}) => {
    return (
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path fillRule="evenodd" clipRule="evenodd" d="M47.2037 65.1023C49.1305 67.0522 52.243 67.0522 54.1698 65.1023L85.5912 33.3043C87.518 31.3544 87.518 28.2046 85.5912 26.2547L61.1359 1.50622C59.2585 -0.493661 56.146 -0.49366 54.2192 1.45622L22.7484 33.3043C20.8216 35.2542 20.8216 38.404 22.7484 40.3538L47.2037 65.1023ZM76.7476 55.0028H80.1071L94.9286 70.0018V90.0006C94.9286 95.5503 90.4821 100 85.0476 100H15.8315C10.397 100 6 95.5003 6 90.0006V70.0018L20.8214 55.0028H24.922L34.803 65.0021H24.675L15.881 75.0015H85.0476L76.303 65.0021H66.8667L76.7476 55.0028ZM15.881 90.0006H85.0476V85.0009H15.881V90.0006ZM75.1667 29.7545L57.6774 12.0555L33.2221 36.804L50.7114 54.5029L75.1667 29.7545Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect width="100" height="100" fill={color} />
                </clipPath>
            </defs>
        </svg>

    )
}

export default IconVocabulary
